import OmsList from "../components/omslist/OmsList";

const OmsListPage = ()=>{
     return(
    <OmsList/>
     )
}
export default OmsListPage;